module.exports = __webpack_public_path__ + "img/bg.ad2f32e9.png";